import GAME from "./../../game";

// returns a specific object by id
export default function getById(id) {
  return [...GAME.game.objectGroup.getAll("stageID", id)];
}
